import React, { useState } from 'react';
import { Grid, TextField, useMediaQuery, useTheme } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import { styled } from '@material-ui/core/styles';
import { theme } from 'theme';
import { SdmSpacer } from 'components/SdmSpacer';
import { SdmTypography } from 'components/SdmTypography';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { SdmTextButton } from 'components/SdmTextButton';
import { useIntl } from 'react-intl';
import translations from 'utils/translations';
import { format } from 'date-fns/esm';
import { slotStatus } from 'utils/constants';
const CustomFormTextField = withStyles({
  root: {
    width: '90%',
    marginLeft: 8,
    '& .MuiFormControl-root': {
      width: '95%',
    },
    '& label.Mui-focused': {
      color: `${theme.colors.primary.black}`,
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: `${theme.colors.primary.black}`,
    },
    '& .MuiInput-underline:before': {
      borderBottom: `2px solid ${theme.colors.primary.black}`,
    },
    '& .MuiInputBase-input': {
      fontFamily: 'Suisse-Intl',
      fontSize: 26,
      color: `${theme.colors.primary.black} !important`,
    },
    '& .MuiFormLabel-root': {
      fontFamily: 'Suisse-Intl',
      color: `${theme.colors.primary.black}`,
      fontSize: 21,
    },
    '& .MuiInput-formControl.MuiInputBase-multiline.MuiInput-multiline': {
      lineHeight: 1,
    },
  },
})(TextField);

const ReferentCard = styled('div')(({ avoidPointer = false }) => ({
  border: `1px solid #D8D8D8`,
  width: 200,
  height: 180,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: 10,
  position: 'relative',
  cursor: avoidPointer ? 'arrow' : 'pointer',
}));

const BookingBrand = ({ onConfirm, onDelete, request, salesTeam, locale }) => {
  // Hooks
  const intl = useIntl();
  const i18n = translations.Agenda(intl).forms;
  const i18nLanguage = translations.Agenda(intl).forms.fields.languages;
  const i18nTicket = translations.Tickets(intl).edit.ticketEditCard;
  const mediaTheme = useTheme();
  const isSmDown = useMediaQuery(mediaTheme.breakpoints.down('sm'));
  const isXsDown = useMediaQuery(mediaTheme.breakpoints.down('xs'));
  // States
  const [selectedReferent, setSelectedReferent] = useState();
  // Functions
  const handleAgree = () => onConfirm?.(selectedReferent);
  const handleDelete = () => onDelete?.(request.id);

  const operatorTypeOptions = [
    { label: i18nTicket.fields.types.adp, value: 'adp' },
    { label: i18nTicket.fields.types.apa, value: 'apa' },
    { label: i18nTicket.fields.types.ret, value: 'ret' },
    { label: i18nTicket.fields.types.acq, value: 'acq' },
    { label: i18nTicket.fields.types.grs, value: 'grs' },
    { label: i18nTicket.fields.types.frn, value: 'frn' },
    { label: i18nTicket.fields.types.agn, value: 'agn' },
    { label: i18nTicket.fields.types.prd, value: 'prd' },
    { label: i18nTicket.fields.types.mrk, value: 'mrk' },
    { label: i18nTicket.fields.types.prv, value: 'prv' },
  ];
  const getRoleOptions = [
    { label: i18nTicket.fields.types.sdm_role_in_company.owner, value: '1007' },
    {
      label: i18nTicket.fields.types.sdm_role_in_company.senior,
      value: '1008',
    },
    {
      label: i18nTicket.fields.types.sdm_role_in_company.junior,
      value: '1009',
    },
    {
      label: i18nTicket.fields.types.sdm_role_in_company.projectManager,
      value: '1010',
    },
    { label: i18nTicket.fields.types.sdm_role_in_company.other, value: '1011' },

    { label: i18nTicket.fields.types.sdm_role_in_company.owner, value: '1012' },
    {
      label: i18nTicket.fields.types.sdm_role_in_company.purchasingDepartment,
      value: '1013',
    },
    { label: i18nTicket.fields.types.projectManager, value: '1014' },
    {
      label: i18nTicket.fields.types.sdm_role_in_company.other,
      value: '1015',
    },

    { label: i18nTicket.fields.types.sdm_role_in_company.ceo, value: '1016' },
    {
      label: i18nTicket.fields.types.sdm_role_in_company.storeManager,
      value: '1017',
    },
    {
      label: i18nTicket.fields.types.sdm_role_in_company.retailOperations,
      value: '1018',
    },
    { label: i18nTicket.fields.types.sdm_role_in_company.buyer, value: '1019' },
    { label: i18nTicket.fields.types.sdm_role_in_company.sales, value: '1020' },
    {
      label: i18nTicket.fields.types.sdm_role_in_company.architect,
      value: '1021',
    },
    {
      label: i18nTicket.fields.types.sdm_role_in_company.assembler,
      value: '1022',
    },
    { label: i18nTicket.fields.types.sdm_role_in_company.other, value: '1023' },

    { label: i18nTicket.fields.types.sdm_role_in_company.owner, value: '1024' },
    {
      label: i18nTicket.fields.types.sdm_role_in_company.purchasingDepartment,
      value: '1025',
    },
    {
      label: i18nTicket.fields.types.sdm_role_in_company.salesDepartment,
      value: '1026',
    },
    {
      label: i18nTicket.fields.types.sdm_role_in_company.marketingDepartment,
      value: '1027',
    },
    { label: i18nTicket.fields.types.sdm_role_in_company.other, value: '1028' },

    { label: i18nTicket.fields.types.sdm_role_in_company.owner, value: '1029' },
    {
      label: i18nTicket.fields.types.sdm_role_in_company.divisionManager,
      value: '1030',
    },
    {
      label: i18nTicket.fields.types.sdm_role_in_company.salesDepartmentFrn,
      value: '1031',
    },
    {
      label: i18nTicket.fields.types.sdm_role_in_company.purchasingDepartment,
      value: '1032',
    },
    { label: i18nTicket.fields.types.sdm_role_in_company.other, value: '1033' },

    { label: i18nTicket.fields.types.sdm_role_in_company.owner, value: '1034' },
    {
      label: i18nTicket.fields.types.sdm_role_in_company.employeeSenior,
      value: '1035',
    },
    {
      label: i18nTicket.fields.types.sdm_role_in_company.employeeJunior,
      value: '1036',
    },
    {
      label: i18nTicket.fields.types.sdm_role_in_company.employeeProjectManager,
      value: '1037',
    },
    { label: i18nTicket.fields.types.sdm_role_in_company.other, value: '1038' },

    {
      label: i18nTicket.fields.types.sdm_role_in_company.businessOwner,
      value: '1001',
    },
    {
      label: i18nTicket.fields.types.sdm_role_in_company.director,
      value: '1002',
    },
    {
      label: i18nTicket.fields.types.sdm_role_in_company.manager,
      value: '1003',
    },
    {
      label: i18nTicket.fields.types.sdm_role_in_company.artisan,
      value: '1004',
    },
    { label: i18nTicket.fields.types.sdm_role_in_company.other, value: '1006' },
  ];

  // Constants
  const values = [
    { label: i18n.fields.givenName, value: request.givenName },
    { label: i18n.fields.familyName, value: request.familyName },
    { label: i18n.fields.email, value: request.email },
    { label: i18n.fields.phone, value: request.phone },
    { label: i18n.fields.language, value: i18nLanguage[request.language] },
    {
      label: i18n.fields.profile,
      value:
        operatorTypeOptions.find((opt) => opt.value === request.profile)
          ?.label || 'N.A',
    },
    { label: i18n.fields.company, value: request.company || 'N.A' },
    {
      label: i18n.fields.role,
      value:
        getRoleOptions.find((opt) => opt.value === request.role)?.label ||
        'N.A',
    },
  ];

  const second = [
    { label: i18n.fields.stand, value: request.stand || 'N.A' },
    { label: i18n.fields.pavillion, value: request.pavillion || 'N.A' },
    {
      label: i18n.fields.date,
      value: format(new Date(request.start), 'dd-MM-yyyy'),
    },
    {
      label: i18n.fields.time,
      value: `${format(new Date(request.start), 'HH:mm')}-${format(
        new Date(request.end),
        'HH:mm'
      )}`,
    },
  ];

  const upperCase = (str) => str[0].toUpperCase() + str.slice(1).toLowerCase();

  const renderStatus = `${
    locale === 'it' ? i18n.fields.request : ''
  } ${upperCase(
    request.status === 'pending' ? i18n.fields.pending : i18n.fields.confirmed
  )} ${locale === 'it' ? '' : i18n.fields.request}`;
  return (
    <Grid container>
      {values.map((v, idx) => (
        <Grid item key={idx} xs={12} md={6}>
          <CustomFormTextField
            value={v.value}
            label={v.label}
            style={{ marginBottom: 10 }}
            disabled={true}
          />
        </Grid>
      ))}
      <SdmSpacer height={isSmDown ? 10 : 50} />
      <Grid item xs={12} md={6}>
        <CustomFormTextField
          value={renderStatus}
          label={i18n.fields.status}
          style={{ marginBottom: 10 }}
          disabled={true}
        />
      </Grid>
      <Grid item xs={false} md={6} />
      {second.map((v, idx) => (
        <Grid item key={idx} xs={12} md={6}>
          <CustomFormTextField
            value={v.value}
            label={v.label}
            style={{ marginBottom: 10 }}
            disabled={true}
          />
        </Grid>
      ))}
      <SdmSpacer height={isSmDown ? 10 : 30} />
      <Grid item xs={12} md={12}>
        {/* <NoteContainer isSmDown={isSmDown}> */}
        <CustomFormTextField
          disabled={true}
          value={request.reason}
          label={`${i18n.fields.reasonUser}`}
          style={{ marginBottom: 10, width: '95%' }}
          multiline
          rows={7}
          maxRows={Infinity}
        />
        {/* </NoteContainer> */}
      </Grid>
      <SdmSpacer height={isSmDown ? 30 : 50} />
      <Grid item xs={12}>
        {salesTeam.length &&
        !request.referent &&
        request.status !== slotStatus.CHECKED ? (
          <SdmTypography variant={isSmDown ? 'h2Regular' : 'h4Regular'}>
            {i18n.fields.chooseCommercial}
          </SdmTypography>
        ) : null}
        <SdmSpacer height={isSmDown ? 10 : 20} />
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: isXsDown ? 'center' : 'flex-start',
            gap: 20,
            flexWrap: 'wrap',
            marginLeft: 8,
          }}
        >
          {salesTeam.length &&
          !request.referent &&
          request.status !== slotStatus.CHECKED ? (
            salesTeam.map((r, idx) => (
              <ReferentCard
                key={idx}
                onClick={() => {
                  const current = selectedReferent;
                  setSelectedReferent(current === r.id ? '' : r.id);
                }}
              >
                <div
                  style={{
                    width: isSmDown ? 40 : 60,
                    height: isSmDown ? 40 : 60,
                    backgroundColor: '#D8D8D8',
                    borderRadius: 50,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <SdmTypography
                    variant={isSmDown ? 'text' : 'h4Regular'}
                    style={{
                      width: '100%',
                      color: theme.colors.primary.black,
                    }}
                  >
                    {r.givenName.charAt(0).toUpperCase()}{' '}
                    {r.familyName.charAt(0).toUpperCase()}
                  </SdmTypography>
                </div>
                <SdmTypography
                  variant={'h3'}
                  margin={0}
                  style={{ textAlign: 'center' }}
                >
                  {r.givenName} {r.familyName}
                </SdmTypography>
                <SdmTypography
                  variant={'h4Regular'}
                  margin={0}
                  style={{ textAlign: 'center' }}
                >
                  {r.role}
                </SdmTypography>
                {selectedReferent === r.id && (
                  <CheckCircleIcon
                    style={{
                      color: theme.colors.primary.red,
                      position: 'absolute',
                      top: 5,
                      right: 5,
                    }}
                  />
                )}
              </ReferentCard>
            ))
          ) : request.referent ? (
            <ReferentCard avoidPointer={true}>
              <div
                style={{
                  width: isSmDown ? 40 : 60,
                  height: isSmDown ? 40 : 60,
                  backgroundColor: '#D8D8D8',
                  borderRadius: 50,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <SdmTypography
                  variant={isSmDown ? 'text' : 'h4Regular'}
                  style={{
                    width: '100%',
                    color: theme.colors.primary.black,
                  }}
                >
                  {request.referent.givenName.charAt(0).toUpperCase()}{' '}
                  {request.referent.familyName.charAt(0).toUpperCase()}
                </SdmTypography>
              </div>
              <SdmTypography variant={'h3'} margin={0} textAlign="center">
                {request.referent.givenName} {request.referent.familyName}
              </SdmTypography>
              <SdmTypography
                variant={'h4Regular'}
                margin={0}
                textAlign="center"
              >
                {request.referent.role}
              </SdmTypography>
            </ReferentCard>
          ) : null}
        </div>
        <Grid item xs={12}>
          <SdmSpacer height={isSmDown ? 50 : 80} />
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: isSmDown ? 'center' : 'flex-end',
              marginRight: isSmDown ? 0 : 30,
            }}
          >
            {request.status === slotStatus.PENDING ||
            request.status === slotStatus.CONFIRMED ? (
              <SdmTextButton
                onClick={handleDelete}
                text={i18n.fields.buttons.delete}
                height={30}
                style={{ width: 158, height: 50, marginRight: 10 }}
                variant={'red'}
                textVariant={'h4Regular'}
              />
            ) : null}
            {request.status === slotStatus.PENDING ||
            (request.status === slotStatus.CONFIRMED &&
              !request.referent &&
              salesTeam.length > 0) ? (
              <SdmTextButton
                text={i18n.fields.buttons.confirm}
                height={30}
                style={{ width: 158, height: 50, marginLeft: 10 }}
                variant={'redFill'}
                textVariant={'h4Regular'}
                onClick={handleAgree}
                disabled={
                  request.status === slotStatus.CONFIRMED &&
                  salesTeam.length > 0 &&
                  !request.referent &&
                  !selectedReferent
                }
              />
            ) : null}
          </div>
        </Grid>
      </Grid>
      <SdmSpacer height={isSmDown ? 30 : 90} />
    </Grid>
  );
};
export { BookingBrand };
